<p-toast [style]="{marginTop: '80px'}"></p-toast>
@if (formLoading) {
  <div class="progress-spinner">
    <app-spinner [formLoading]="formLoading"></app-spinner>
  </div>
}
<div class="slide-toggle-top d-flex align-items-center mb-4">
  <mat-slide-toggle class="w-100" formControlName="syncShortName" (change)="syncShortNameChange($event)">Sync Short Name?
  </mat-slide-toggle>
  <!-- <span class="p-float-label">
  <p-dropdown [options]="ruAccounts" [(ngModel)]="ruAccount" (onChange)="onRUAccount($event)"
    optionLabel="name" optionValue="value" [filter]="false"
    [showClear]="false" placeholder="RUAccount">
  </p-dropdown>
  <label for="ruAccount">Select RU Account</label>
</span> -->

</div>

<div class="pl-4 pr-4" [formGroup]="form1">

  <p-fieldset styleClass="p-fluid " legend="Property Admin" [toggleable]="true" [collapsed]="true">
    <div class="p-formgrid grid">
      <div class="col-12">
        Global property admins for Rentals United.
      </div>

      <div class="flex justify-content-end mt-3">
        @if (formErrorMessage) {
          <small class="p-invalid"><br>{{formErrorMessage}}<br></small>
        }
        <br>
          <button pButton type="button" class="p-button-danger" label="Sync All Properties" (click)="onSaveAllPropertiesClick()"></button>
        </div>
      </div>
    </p-fieldset>
    <br>
      <p-fieldset styleClass="p-fluid " legend="Sync Property" [toggleable]="true" [collapsed]="true">
        <div class="p-formgrid grid">
          <div class="col-12">
            Add or update a property to Rental United.
          </div>

          <div class="p-field col-12 mt-6">

            <span class="p-float-label">
              <p-dropdown [options]="shortTermRentals" formControlName="shortTermRentalId" optionLabel="propertyCode" optionValue="shortTermRentalId" [filter]="true" filterBy="propertyCode" [showClear]="false"
                placeholder="Select Property">
              </p-dropdown>
              <label for="developmentId">Select Property</label>
              @for (validation of validationMessages.shortTermRentalId; track validation) {
                <span>
                  @if (form1.get('shortTermRentalId').hasError(validation.type) && (form1.get('shortTermRentalId').dirty || form1.get('shortTermRentalId').touched)) {
                    <small id="developmentId-help" class="p-invalid"
                      >{{validation.message}}
                    </small>
                  }
                </span>
              }
            </span>
          </div>


          <!-- <div  class="p-field col-12 mt-3">
          <span class="p-float-label">
            <input formControlName="addressDevelopmentName" id="addressDevelopmentName" type="text" pInputText>
            <label for="addressDevelopmentName">Building Name</label>
            <span *ngFor="let validation of validationMessages.addressDevelopmentName">
              <small id="addressDevelopmentName-help" class="p-invalid"
                *ngIf="form1.get('addressDevelopmentName').hasError(validation.type) && (form1.get('addressDevelopmentName').dirty || form1.get('addressDevelopmentName').touched)">{{validation.message}}
              </small>
            </span>
          </span>
        </div> -->

        @if (form1.value.shortTermRentalId) {
          <div class="mt-3">
            @if (formErrorMessage) {
              <small class="p-invalid"><br>{{formErrorMessage}}<br></small>
            }
            <br>
              <button pButton type="button" label="Sync Property" (click)="onFormSubmit()"></button>
              <div> <br><br>
                <a target="_blank" [routerLink]="['/logmans/short-term-rental', 'SAVE_RU_PROPERTY',this.form1.value.shortTermRentalId]"> View Logman for shortTermRentalId #{{this.form1.value.shortTermRentalId}}</a>
              </div>
            </div>
          }
        </div>
      </p-fieldset>


      <br>
        <br>

          <h2>Properties</h2>
          <p-table [value]="ruProperties">
            <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="LastMod.Active">Status<br>
                  <p-sortIcon field="LastMod.Active"></p-sortIcon>
                </th>

                <th pSortableColumn="ID.BuildingName">Building <br>
                  <p-sortIcon field="ID.BuildingName"></p-sortIcon>
                </th>
                <th pSortableColumn="Name">Property<br>
                  <p-sortIcon field="Name"></p-sortIcon>
                </th>
                <th pSortableColumn="LastMod.lastUpdate">Last Update<br>
                  <p-sortIcon field="LastMod.lastUpdate"></p-sortIcon>
                </th>
                <th pSortableColumn="ID.BuildingID">BuildingID<br>
                  <p-sortIcon field="ID.BuildingID"></p-sortIcon>
                </th>
                <th pSortableColumn="ID.PropertyID">PropertyID<br>
                  <p-sortIcon field="ID.PropertyID"></p-sortIcon>
                </th>
                <th pSortableColumn="OwnerID">OwnerID<br>
                  <p-sortIcon field="OwnerID"></p-sortIcon>
                </th>
                <th pSortableColumn="DetailedLocationID.LocationID">LocationID<br>
                  <p-sortIcon field="DetailedLocationID.LocationID"></p-sortIcon>
                </th>
                <th pSortableColumn="DateCreated">DateCreated<br>
                  <p-sortIcon field="DateCreated"></p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-property>
              <tr>
                <td>{{(property.LastMod.Active === true) ? 'Active' :'Suspended'}}</td>
                <td>{{property.ID.BuildingName}}</td>
                <td><b>{{property.Name}}</b></td>
                <td>{{property.LastMod.lastUpdate | date}}</td>
                <td>{{property.ID.BuildingID}}</td>
                <td>{{property.ID.PropertyID}}</td>
                <td>{{property.OwnerID}}</td>
                <td>{{property.DetailedLocationID.LocationID}}</td>
                <td>{{property.DateCreated | date}}</td>
              </tr>
            </ng-template>
          </p-table>
        </div>